import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const REQUIREMENTS = [
    { label: 'Almeno 8 caratteri', test: (p) => p.length >= 8 },
    { label: 'Una lettera maiuscola', test: (p) => /[A-Z]/.test(p) },
    { label: 'Una lettera minuscola', test: (p) => /[a-z]/.test(p) },
    { label: 'Un numero', test: (p) => /[0-9]/.test(p) },
    { label: 'Un carattere speciale (!@#$%...)', test: (p) => /[^A-Za-z0-9]/.test(p) },
];
export function PasswordRequirements({ password }) {
    if (!password)
        return null;
    return (_jsx("ul", { className: "ipsoft-password-requirements", "aria-label": "Requisiti password", children: REQUIREMENTS.map((req) => {
            const met = req.test(password);
            return (_jsxs("li", { className: met ? 'ipsoft-requirement-met' : 'ipsoft-requirement-unmet', children: [_jsx("span", { className: "ipsoft-requirement-icon", "aria-hidden": "true", children: met ? '✓' : '✗' }), _jsx("span", { children: req.label })] }, req.label));
        }) }));
}
/**
 * Check if all password requirements are met.
 */
export function isPasswordValid(password) {
    return REQUIREMENTS.every((req) => req.test(password));
}
//# sourceMappingURL=PasswordRequirements.js.map